import * as i0 from '@angular/core';
import { NgModule, Injectable } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import * as i3 from 'ngx-device-detector';

class BqxDealModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: BqxDealModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.8", ngImport: i0, type: BqxDealModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: BqxDealModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: BqxDealModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [],
                    exports: [],
                }]
        }] });

class AbstractDealConfigService {
}

var Actions;
(function (Actions) {
    Actions["ButtonClick"] = "buttonClick";
    Actions["Change"] = "change";
    Actions["CheckBoxChange"] = "checkBoxChange";
    Actions["DropdownChange"] = "dropdownChange";
    Actions["LinkClick"] = "linkClick";
    Actions["Message_Displayed"] = "message_Displayed";
    Actions["RadioButtonChange"] = "radioButtonChange";
    Actions["TextBoxFocus"] = "textBoxFocus";
    Actions["TextBoxBlur"] = "textBoxBlur";
    Actions["PageLoad"] = "virtualPageLoad";
})(Actions || (Actions = {}));

class DealAbstractService {
}

class DealService {
    constructor(http, configService, deviceService) {
        this.http = http;
        this.configService = configService;
        this.deviceService = deviceService;
    }
    postEvent(event, hitType, url, virtualPage, pageTitle, privacy) {
        const httpHeaders = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + this.configService.apiToken,
        });
        const message = this.createMessage(event, hitType, pageTitle, virtualPage, url, privacy);
        this.http
            .post(this.configService.dealUrl, message, {
            headers: httpHeaders,
            responseType: 'json',
        })
            .subscribe({
            error: (err) => {
                this.configService.log(err);
            },
        });
    }
    createMessage(event, hitType, pageTitle, virtualPage, url, privacy) {
        return {
            event,
            hitType,
            domain: this.configService.domain,
            application: this.configService.application,
            privacy,
            browser: {
                url,
                viewPort: `${window.innerWidth}x${window.innerHeight}`,
            },
            configuration: {
                userAgent: navigator.userAgent,
                locale: navigator.language,
            },
            device: {
                category: this.getDeviceType(),
                resolution: `${screen.width}x${screen.height}`,
            },
            pageTitle: pageTitle,
            virtualPage: virtualPage,
            slSSID: this.configService.slssid,
            hitDtTm: new Date().toISOString(),
        };
    }
    getDeviceType() {
        switch (true) {
            case this.deviceService.isMobile():
                return 'Mobile';
            case this.deviceService.isTablet():
                return 'Tablet';
            default:
                return 'Desktop';
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: DealService, deps: [{ token: i1.HttpClient }, { token: AbstractDealConfigService }, { token: i3.DeviceDetectorService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: DealService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: DealService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: AbstractDealConfigService }, { type: i3.DeviceDetectorService }] });

var HitTypes;
(function (HitTypes) {
    HitTypes["Event"] = "event";
    HitTypes["Page"] = "page";
})(HitTypes || (HitTypes = {}));

/*
 * Public API Surface of bqx-deal
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AbstractDealConfigService, Actions, BqxDealModule, DealAbstractService, DealService, HitTypes };
